import React from "react";

// Define Button component
const Button = ({
  type = "primary",
  size = "md",
  onClick,
  children,
  className = "",
}) => {
  const typeClasses = {
    primary:
      "bg-[#1e81b0] text-white hover:bg-[#1384ba] focus:ring-4 focus:ring-[#1e81b0] rounded-md",
    secondary:
      "bg-[#8ccfee] text-black hover:bg-[#66c2ed] focus:ring-4 focus:ring-[#8ccfee] rounded-md",
    danger:
      "bg-red-500 text-white hover:bg-red-600 focus:ring-4 focus:ring-red-300",
    success:
      "bg-green-500 text-white hover:bg-green-600 focus:ring-4 focus:ring-green-300",
  };

  const sizeClasses = {
    sm: "py-1 px-4 text-sm",
    md: "py-1 px-4 text-base",
    lg: "py-1 px-4 text-lg",
  };

  // Combine the classes based on the `type` and `size`
  const buttonClassNames = `btn ${typeClasses[type]} ${sizeClasses[size]} ${className} `;

  return (
    <button onClick={onClick} className={buttonClassNames}>
      {children}
    </button>
  );
};

export default Button;
